// extracted by mini-css-extract-plugin
export default {"socialMediaIcon":"GithubLinks_socialMediaIcon_Q56hu"};